import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.666 11h3.232a.5.5 0 0 1 .376.83L17 19v3h2.5a.5.5 0 1 1 0 1h-6a.5.5 0 1 1 0-1H16v-3l-6.274-7.17a.5.5 0 0 1 .376-.83h8.375l-2.398 3.73a.5.5 0 1 0 .842.54L19.666 11zM8.165 12H2.1a.1.1 0 0 1-.1-.1V9a2 2 0 0 1 2-2h1V2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5h1a2 2 0 0 1 2 2v.5h-1.898A2 2 0 0 0 8.165 12zm.592 1L12 16.706v.194a.1.1 0 0 1-.1.1H2.1a.1.1 0 0 1-.1-.1v-3.8a.1.1 0 0 1 .1-.1h6.657zM2.1 18h9.8a.1.1 0 0 1 .1.1V22a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3.9a.1.1 0 0 1 .1-.1zm16.377-7l2.102-3.27a.5.5 0 1 1 .842.54L19.666 11h-1.189z"
});

var SvgAlcoholFilled = function SvgAlcoholFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgAlcoholFilled;